import { UPDATE_RESET_PASSWORD_IS_FETCHING } from '../constants/actions';

const DEFAULT_RESET_PASSWORD_STATE = {
  is_fetching: false,
};

const resetPasswordReducer = (state = DEFAULT_RESET_PASSWORD_STATE, action) => {
  switch (action.type) {
    case UPDATE_RESET_PASSWORD_IS_FETCHING:
      return {
        ...state,
        is_fetching: action.is_fetching,
      };
    default:
      return state;
  }
};

export default resetPasswordReducer;
